module.exports = __webpack_public_path__ + "img/img_logo.614c5c75.png";